import { Controller, useForm } from "react-hook-form";
import { Dialog } from "components/Dialog";
import { Button } from "components/Button";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";

import { TEditFormTypes } from "../EditProvinceModal";

type TProps = {
  isOpen?: boolean;
  onClose: () => void;
  onSubmit: (value: TEditFormTypes) => void;
  isLoading: boolean;
};

export type TAddFormTypes = {
  name: string;
};

export function AddProvinceModal(props: TProps) {
  const { isOpen = false, onClose, onSubmit, isLoading } = props;
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<TAddFormTypes>({
    defaultValues: {
      name: undefined,
    },
  });

  return (
    <Dialog
      maxWidth={false}
      dialogTitle={t("addProvince")}
      open={isOpen}
      onClose={onClose}
      canClose={!isLoading}
    >
      <form className="p-4 w-[640px]" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex w-1/2">
          <Controller
            name={"name"}
            control={control}
            rules={{
              required: "الزامی است",
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  placeholder={t("name")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                />
              );
            }}
          />
        </div>
        <div className="col-span-12 flex items-center justify-end mt-3">
          <Button
            className="w-20"
            loading={isLoading}
            type="submit"
            variant="contained"
          >
            {t("add")}
          </Button>
        </div>
      </form>
    </Dialog>
  );
}
